import React, { createContext, ReactNode, useMemo } from 'react';

export type SubjectMonitoringState = {
    studyRef: string;
    datasetId: number;
};

export const SubjectMonitoringContext = createContext<SubjectMonitoringState>({
    studyRef: '',
    datasetId: 0,
});

type Props = {
    children: ReactNode;
    orgRef: string;
    studyRef: string;
    datasetId: number;
};

export const SubjectMonitoringProfileContextProvider = ({ children, orgRef, studyRef, datasetId }: Props) => {
    return (
        <SubjectMonitoringContext.Provider
            value={useMemo(
                () => ({
                    orgRef,
                    studyRef,
                    datasetId,
                }),
                [orgRef, studyRef, datasetId],
            )}
        >
            {children}
        </SubjectMonitoringContext.Provider>
    );
};
